<style>

.insert_dialog {
  width: 60%;
}

</style>

<!-- INSERT DIALOG -->
<template>
<v-dialog v-model="show" class='insert_dialog'>
    <v-card>
    <v-card-title>Inserisci Contenzioso/Revisione</v-card-title>
    <v-card-text>
        <v-form @submit.prevent="confirmInsert">
        <v-select
            v-model="new_litigation.type"
            :items="type_options.map(t => t.value)"
            :label="(headers.find(h => h.value === 'type') || headers_details_additional.find(h => h.value === 'type'))?.title"
            dense
        >
        </v-select>
        <v-select
            v-model="new_litigation.error_type"
            :items="error_type_options.map(t => t.value)"
            :label="(headers.find(h => h.value === 'error_type') || headers_details_additional.find(h => h.value === 'error_type'))?.title"
            dense
        >
        </v-select>    
        <v-text-field 
            v-model="new_litigation.protocol"
            :label="(headers.find(header => header.value === 'protocol') || headers_details_additional.find(h => h.value === 'protocol'))?.title"
            dense
        ></v-text-field>
        <v-date-input 
            v-model="new_litigation.notification_date"
            :label="(headers.find(h => h.value === 'notification_date') || headers_details_additional.find(h => h.value === 'notification_date'))?.title"
            dense
        ></v-date-input>
        <v-date-input 
            v-model="new_litigation.expiration_date"
            :label="(headers.find(h => h.value === 'expiration_date') || headers_details_additional.find(h => h.value === 'expiration_date'))?.title"
            dense
        ></v-date-input>
        <v-select
            v-model="new_litigation.in_charge_of"
            :items="['Azienda', 'Cliente']"
            :label="(headers.find(h => h.value === 'in_charge_of') || headers_details_additional.find(h => h.value === 'in_charge_of'))?.title"
            dense
        >
        </v-select>
        <v-select
            v-model="new_litigation.representation"
            :items="['Diretta', 'Indiretta']"
            :label="(headers.find(h => h.value === 'representation') || headers_details_additional.find(h => h.value === 'representation'))?.title"
            dense
        >
        </v-select>
        <v-select
            v-model="new_litigation.invoiced"
            :items="['Si', 'No']"
            :label="(headers.find(h => h.value === 'invoiced') || headers_details_additional.find(h => h.value === 'invoiced'))?.title"
            dense
        >
        </v-select>
        <v-textarea
            v-model="new_litigation.notes"
            :label="(headers.find(h => h.value === 'notes') || headers_details_additional.find(h => h.value === 'notes'))?.title"
            variant="outlined"
            rows="3"
            dense
        ></v-textarea>
        
        <!-- altri campi da aggiungere -->
        <v-btn 
            type="submit"
            prepend-icon="mdi-check"
            variant="tonal">
            Inserisci
        </v-btn>
        </v-form>
    </v-card-text>
    </v-card>
</v-dialog>
<snackbarTemplate ref="snackbar" />
</template>
 

<script>
    import axios from 'axios';
    import snackbarTemplate from './Snackbar.vue'

    export default {
        name: 'insertDialog',
        emits: ['insert-completed'],
        components: {
            snackbarTemplate,
        },
        data() {
            return {
                show: false,
                new_litigation: {},
                headers: [],
                headers_details_additional: [],
            } 
        },
        props: {
            type_options: Array,
            error_type_options: Array,
        },
        methods: {
            formatDateBeforeInsert(date) {
                const year = date.getFullYear();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const day = date.getDate().toString().padStart(2, '0');
                return `${year}-${month}-${day}`;
            },
            confirmInsert() {
                axios.post('/api/litigations/', {
                    status: "Aperta",
                    protocol: this.new_litigation.protocol,
                    notification_date: this.new_litigation.notification_date instanceof Date ? this.formatDateBeforeInsert(this.new_litigation.notification_date) : null,
                    expiration_date: this.new_litigation.expiration_date instanceof Date ? this.formatDateBeforeInsert(this.new_litigation.expiration_date) : null,
                    invoiced: this.new_litigation.invoiced, 
                    in_charge_of: this.new_litigation.in_charge_of,
                    representation: this.new_litigation.representation,
                    type_id: this.type_options.find(t => t.value === this.new_litigation.type)?.key,
                    error_type_id: this.error_type_options.find(t => t.value === this.new_litigation.error_type)?.key,
                    notes: this.new_litigation.notes,
                    mrn_list: []
                    }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                    })
                    .then(response => {
                    console.log('Richiesta inviata:', axios.defaults.headers.common);
                    console.log('Response ricevuta:', response)
                    this.$emit('insert-completed')
                    this.show = false;
                    })
                    .catch(error => {
                    console.error(error)
                    this.$refs.snackbar.snackbar_message = error.request.responseText;
                    this.$refs.snackbar.snackbar_style = 'error';
                    this.$refs.snackbar.show = true;
                    });
            }
        }
    }      
</script>